import { Action } from '@ngrx/store';

export const FETCH =                 '[Comparison] FETCH';
export const FETCH_SUCCESS =         '[Comparison] FETCH_SUCCESS';
export const FETCH_FAIL =            '[Comparison] FETCH_FAIL';
export const REMOVE_COMPANY =        '[Comparison] REMOVE_COMPANY';
export const REORDER_COMPANIES =     '[Comparison] REORDER_COMPANIES';
export const SET_CHART =             '[Comparison] SET_CHART';

interface ReorderIndexes {
  from: number;
  to: number;
}
/**
 * Load Comparison Actions
 */
export class FetchCompanyForComparison implements Action {
  readonly type = FETCH;
  constructor(public payload: any) { }
}

export class FetchCompanyForComparisonSuccess implements Action {
  readonly type = FETCH_SUCCESS;

  constructor(public payload: any) { }
}

export class FetchCompanyForComparionsFail implements Action {
  readonly type = FETCH_FAIL;

  constructor(public payload: any) { }
}

export class RemoveCompanyFromComparison implements Action {
  readonly type = REMOVE_COMPANY;

  constructor(public payload: number) { }
}

export class ReorderCompanyComparison implements Action {
  readonly type = REORDER_COMPANIES;
  constructor(public payload: ReorderIndexes) { }
}

export class SetChart implements Action {
  readonly type = SET_CHART;

  constructor(public payload: string) { }
}
SetChart

export type Actions =
  | FetchCompanyForComparison
  | FetchCompanyForComparisonSuccess
  | FetchCompanyForComparionsFail
  | RemoveCompanyFromComparison
  | ReorderCompanyComparison
  | SetChart;


// WEBPACK FOOTER //
// ./src/actions/comparison.actions.ts